import { Injectable } from "@angular/core";
import {
  HttpBackend,
  HttpClient,
  HttpErrorResponse,
  HttpEvent,
  HttpHeaders,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { tap, catchError, map } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { SnackbarService } from "../../shared/components/snackbar/snackbar.service";
import { errorType } from "../constants";

@Injectable()
export class ApiService {

  // login = '/api/auth/login';
  login = `${environment.apiLogin}/auth/login/web`;
  loginByEmail = `${environment.apiLogin}/user/login/email`;

  apiAuth = `${environment.apiLogin}`;
  loginAuthorize = `${environment.apiLogin}/auth/user-identity/authorize`;
  userIdentity = `${environment.apiLogin}/auth/user-identity`;
  loginAuthorizeStock = `${environment.apiLogin}/authorize/`;
  authorization = `${environment.apiAuthorization}`;
  userEntity = `${environment.apiLogin}/user`;
  changePassword = `${environment.apiLogin}/auth/user-identity/change-password`;
  // Sale - order-payment
  searchProduct = `${environment.apiProducts}/api/business-irdgco-product/v1/products`;
  loadDatesDelivery = `${environment.apiDelivery}/delivery/calendar/dates`;
  datesDelivery = `${environment.apiDelivery}/delivery/capacity`;
  freightDelivery = `${environment.apiDelivery}/delivery/freight`;
  stockDelivery = `${environment.apiBusinessInventory}/api/business-irdgco-inventory-read/v1/stock`;
  stockIntegral = `${environment.apiIntegRoute}/routes/entity_origins`;
  cancellation = `${environment.apiCancellation}`;
  orderPayment = `${environment.apiOrderPayment}`;
  getServices = `${environment.apiAdditional}/additional`;
  customer = `${environment.apiCustomer}/api/business-irdgco-dad-customer/v1`;
  addresses = `${environment.apiCustomer}/api/business-irdgco-dad-customer/v1/addresses`;
  message = `${environment.apiMessage}/send`;
  messageEmail = `${environment.apiMessage}/sendEmail`;
  messageSms = `${environment.apiMessage}/sendSms`;
  messageMCA = `${environment.apiMessage}/sendEmailMCA`;
  messaging = `${environment.apiMessage}/messaging/`;
  // configuration
  routes = `${environment.apiRoutes}/routes`;
  dispatchZone = `${environment.apiDispatchZone}/api/business-irdgco-zones/v1`;
  configuration = `${environment.apiConfiguration}/group/{{groupCode}}`;
  configurationGroup = `${environment.apiConfiguration}/group`;
  configurationBulk = `${environment.apiConfiguration}/groups/{{groupCode}}`;
  entityRoutes = `${environment.apiRoutes}/route`;
  holidayExceptions = `${environment.apiRoutes}/holiday-exceptions`;
  entityRoutesByType = `${environment.apiRoutes}/route/type/{{entityType}}`;
  entityRoutesByEntity = `${environment.apiRoutes}/route/entity/{{entityCode}}`;
  entityRoutesConfigure = `${environment.apiRoutes}/route/dispatch`;
  dispatchRoutes = `${environment.apiRoutes}/dispatch-route`;
  dispatchRoutesByType = `${environment.apiRoutes}/dispatch-route/type/{{entityType}}`;
  dispatchRoutesByEntity = `${environment.apiRoutes}/dispatch-route/entity/{{entityCode}}`;
  dispatchRoutesConfigure = `${environment.apiRoutes}/dispatch-route/dispatch`;
  dispatchRoutesMassEdit = `${environment.apiRoutes}/dispatch-route/mass-edit`;
  dispatchDates = `${environment.apiRoutes}/dispatch-dates`;
  shipping = `${environment.apiShipping}/shipping`;
  securityStock = `${environment.apiInventory}/security-stock`;
  securityStockCes = `${environment.apiCentralizedStockConfiguration}/api/centralized-stock-configuration/v1/security-stock`;
  integRoute = `${environment.apiIntegRoute}/routes`;
  integRouteConflicts = `${environment.apiIntegRoute}/routes/conflicts`;
  integRouteDisable = `${environment.apiIntegRoute}/routes/disable`;
  integRouteReturn = `${environment.apiIntegRoute}/routes/return`;
  integRouteEnabled = `${environment.apiIntegRoute}/routes/enabled`;
  integRoutePriorities = `${environment.apiIntegRoute}/routes/priorities`;
  integRouteUnconfigured = `${environment.apiIntegRoute}/routes/unconfigured_zones`;
  integRouteWithdrawOrigins = `${environment.apiIntegRoute}/routes/withdraw_destinations`;
  dispatchOrders = `${environment.apiRoutes}/dispatch-orders`;
  getStatusOrderPicking = `${environment.apiPicking}/orders/states`;
  getShiftOrderPicking = `${environment.apiPicking}/commons/turn`;
  // getShiftOrderPicking = `${environment.apiPickingMock}/orders/shift`;
  getOrdersPicking = `${environment.apiPicking}/orders`;
  getOrdersPickingReport = `${environment.apiRunPickingReport}/orders`;
  getAuditReport = `${environment.apiRunPickingReport}/audit/report`;
  getPickers = `${environment.apiBusinessPickingRead}/api/business-irdgco-picking-read/v1/pickers`;
  updateOrderPicking = `${environment.apiPicking}/orders/assign`;
  pickingReport = `${environment.apiRunPickingReport}`;
  orders = `${environment.apiwithdraw}/orders`;
  exchangeOrders = `${environment.apiBusinessDispatchRead}/api/business-irdgco-dispatch-read/v1/orders`;
  getItem = `${environment.apiBusinessDispatchRead}/api/business-irdgco-dispatch-read/v1/dispatches/{{dispatchNumber}}/items`;
  inStoreLocation = `${environment.apiwithdraw}/location`;
  deliveryImages = `${environment.apiwithdraw}/deliveryImages`;
  verifyUpdatePriceUserAuthz = `${environment.apiLogin}/user/price/authz`;
  validatePriceDiscountCode = `${environment.apiProducts}/api/business-irdgco-product/v1/products/valid/discountcode`;
  getDiscountsByProducts = `${environment.apiPromotion}/promotion/`;
  getAuthorizeCodePromotion = `${environment.apiProducts}/api/business-irdgco-product/v1/authorize/consume`;
  dispatch = `${environment.apiActionDispatch}/dispatch`;
  customerIntegration = `${environment.apiBusinessCustomerIntegration}/api/business-irdgco-customer-integration/v1`;
  // DESPACHO A CLIENTES
  dispatchToCustomer = `${environment.apiActionDispatch}/delivery`;
  dispatchToLocation = `${environment.apiActionDispatch}/location`;
  dispatchMassiveLocation = `${environment.apiBusinessDispatchRead}/api/business-irdgco-dispatch-read/v1/dispatch/location`;
  // TRANSPORTISTAS
  carriers = `${environment.apiActionDispatch}/dispatch/carrier`;
  // VIAJES
  trips = `${environment.apiActionDispatch}/dispatch/trips`;
  // REENVÍO
  resend = `${environment.apiActionDispatch}/dispatch/trips/resend`;
  // AGREGAR DESPACHO
  addDispatchToTrip = `${environment.apiActionDispatch}/dispatch/trip/add`;
  // Report
  report = `${environment.apiReport}`;
  userReport = `${environment.apiUserReport}/graphql`;
  //Quotations
  quotations = `${environment.apiQuotation}/quotations`;
  getMarginCommercial = `${environment.apiInventory}/comercial-margin/calcule`;
  massiveStock = `${environment.apiMassiveStock}/conditions/stock`;
  msQuotation = `${environment.apiMsQuotation}`;
  quotationRead = `${environment.apiQuotationRead}/api/business-irdgco-quotation-read/v1`;

  apiAudit = `${environment.apiRunPickingReport}/audit`;
  businessEntity = `${environment.apiBusinessEntity}/api/business-irdgco-entity/v1`;
  //picking
  containerReallocation = `${environment.apiPicking}/picking/containerReallocation`;
  businessPicking = `${environment.apiBusinessPicking}/api/business-irdgco-picking/v1`;
  businessPickingRead = `${environment.apiBusinessPickingRead}/api/business-irdgco-picking-read/v1`;

  //DASHBOARD
  dashboard = `${environment.apiDashboard}/api/business-irdgco-dashboard/v1`;
  tripCompliance = `${this.dashboard}/tripCompliance`;
  deliveryDate = `${this.dashboard}/deliveryDate`;
  closedDispatch = `${this.dashboard}/closedDispatch`;
  deliveryConfirmation = `${this.dashboard}/deliveryConfirmation`;
  pickingDateVsSaleDate = `${this.dashboard}/pickingDateVsSaleDate`;
  pickupDateByClient = `${this.dashboard}/pickupDateByClient`;

  //DATA - UTILIZACION DaD - REPORT
  tripComplianceToReport       = `${this.dashboard}/tripComplianceToReport`;
  deliveryDateToReport         = `${this.dashboard}/deliveryDateToReport`;
  closedDispatchToReport       = `${this.dashboard}/closedDispatchToReport`;
  deliveryConfirmationToReport = `${this.dashboard}/deliveryConfirmationToReport`;
  pickingDateVsSaleDateToReport = `${this.dashboard}/pickingDateVsSaleDateToReport`;
  pickupDateByClientToReport   = `${this.dashboard}/pickupDateByClientToReport`;



  //DESPACHO A DOMICILIO
  deliveryCompliance     = `${this.dashboard}/deliveryCompliance`;
  complianceInfull       = `${this.dashboard}/complianceInfull`;
  deliveryComplianceByCompany  = `${this.dashboard}/deliveryComplianceByCompany`;
  deliveryComplianceByPlatform = `${this.dashboard}/deliveryComplianceByPlatform`;

  //RETIRO EN TIENDA
  arrivalComplianceByCompany      = `${this.dashboard}/arrivalComplianceByCompany`;
  arrivalComplianceByPlatform     = `${this.dashboard}/arrivalComplianceByPlatform`;
  arrivalComplianceByDispatch     = `${this.dashboard}/arrivalComplianceByDispatch`;
  complianceLocationByCompany     = `${this.dashboard}/complianceLocationByCompany`;
  complianceLocationByDispatch    = `${this.dashboard}/complianceLocationByDispatch`;


  //CONSOLIDADO
  complianceSaleNoteByCompany     = `${this.dashboard}/complianceSaleNoteByCompany`;
  complianceSaleNoteByPlatform    = `${this.dashboard}/complianceSaleNoteByPlatform`;
  complianceSaleNoteByDispatch    = `${this.dashboard}/complianceSaleNoteByDispatch`;
  deliveryComplianceByOrigin      = `${this.dashboard}/deliveryComplianceByOrigin`;
  storePickupOrHomeDeliveryByType = `${this.dashboard}/storePickupOrHomeDeliveryByType`;

  //DATA EXPORT - DESPACHO A DOMICLIO
  deliveryComplianceByCompanyToExport  = `${this.dashboard}/deliveryComplianceByCompanyToExport`;
  deliveryComplianceByTypeToExport     = `${this.dashboard}/deliveryComplianceByTypeToExport`;
  complianceInfullToExport             = `${this.dashboard}/complianceInfullToExport`;

   //DATA EXPORT - RETIRO EN TIENDA
   arrivalComplianceOfSalesNotesToExport = `${this.dashboard}/arrivalComplianceOfSalesNotesToExport`;
   arrivalComplianceByOriginToExport     = `${this.dashboard}/arrivalComplianceByOriginToExport`;
   locationComplianceByCompanyToExport   = `${this.dashboard}/locationComplianceByCompanyToExport`;
   locationComplianceByOriginToExport    = `${this.dashboard}/locationComplianceByOriginToExport`;


  //DATA EXPORT - CONSOLIDADO
  complianceSaleNoteToExport = `${this.dashboard}/complianceSaleNoteToExport`;
  deliveryComplianceByOriginToExport   = `${this.dashboard}/deliveryComplianceByOriginToExport`;
  storePickupOrHomeDeliveryToExport    = `${this.dashboard}/storePickupOrHomeDeliveryToExport`;
  orderPaymentRead = `${environment.apiOrderPaymentRead}/api/business-irdgco-order-payment-read/v1`;

  businessDispatchRead = `${environment.apiBusinessDispatchRead}/api/business-irdgco-dispatch-read/v1`;

  //BUSINESS LOGIN INTEGRATION
  businessLoginIntegration  = `${environment.apiBusinessLoginIntegration}/api/business-irdgco-login-integration/v1`;
  businessCapacity = `${environment.apiBusinessCapacity}/api/business-irdgco-capacity/v1`;

  refundsReport = `${environment.apiActionDispatch}/dispatch/report`;


  configRuleService = `${environment.apiConfigRuleService}/api/business-irdgco-rules-service/v1`;
  centralizedStock = `${environment.apiBusinessCentralizedStock}/api/centralized-stock-read/v1`;


  endpointExceptions =  [
    'https://ipapi.co/json',
    this.holidayExceptions
  ];

  //BUSINESS DISPATCH
  businessDispatchIntegration  = `${environment.apiBusinessDispatch}/api/business-irdgco-dispatch/v1`;
  exchangeItemsOfDispatch  = `${this.businessDispatchIntegration}/dispatches/{{dispatchNumber}}/items/exchange`;

  //BUSINESS MULTIMEDIA
  businessMultimedia = `${environment.apiBusinessMultimedia}/api/v1`;

  businessManintenaceLogistic = `${environment.apiBusinessMaintenanceLogistic}/api/business-irdgco-maintenance-logistic/v1`;
  businessLogistic = `${environment.apiBusinessLogistic}/api/business-irdgco-logistic/v1`;

  // Azure endpoints
  azureQueryWithWiql = `${environment.azure.apiAzureDevops}/${environment.azure.organization}/${environment.azure.project}/${encodeURIComponent(environment.azure.team)}/_apis/wit/wiql?api-version=7.1`;
  azureGetSummarizeWorkItems = `${environment.azure.apiAzureDevops}/${environment.azure.organization}/${environment.azure.project}/_apis/wit/workitems?ids={{itemsIds}}&fields=${encodeURIComponent(environment.azure.summaryWorkItemFields)}&api-version=7.1`;

  constructor(
    private http: HttpClient,
    private httpBackend: HttpBackend,
    public snackbarService: SnackbarService
  ) {}

  public formatErrors(error: HttpErrorResponse, path?: string) {
    const messageError = error.error ? error.error.message : error;
    const isException = !!path && this.endpointExceptions
    .filter(e => typeof e === 'string')
    .some(e => path.startsWith(e));
    if (!isException)
      this.snackbarService.show(messageError, error.status === 404 ? "warning" : "error");
    if (error && error.error && error.error.errorType && error.error.errorType === errorType.AUTH04) {
      return throwError(error);
    } else {
      return throwError(messageError);
    }
  }

  get(path: string, params?: any): Observable<any> {
    return this.http.get(path, { params }).pipe(
      catchError((error) => {
          return this.formatErrors(error,path);
      })
    );
  }

  getWithoutInterceptor(url: string): Observable<any>{
    const base64Credentials = btoa(`${environment.config_enable_login.basic_user}:${environment.config_enable_login.basic_pass}`);
    const headers = new HttpHeaders({
      'Authorization': `Basic ${base64Credentials}`
    });
    const request = new HttpRequest('GET', url, { headers });
    const httpWithoutInterceptors = new HttpClient(this.httpBackend);
   return httpWithoutInterceptors.request(request).pipe(
     catchError((error) => {
          return this.formatErrors(error,url);
      })
    );
  }

  postWithoutInterceptor(url: string, paramBody:any): Observable<any>{
    const base64Credentials = btoa(`${environment.config_enable_login.basic_user}:${environment.config_enable_login.basic_pass}`);
    const headers = new HttpHeaders({
      'Authorization': `Basic ${base64Credentials}`
    });
    const request = new HttpRequest('POST', url, paramBody, { headers });
    const httpWithoutInterceptors = new HttpClient(this.httpBackend);
    return httpWithoutInterceptors.request(request).pipe(
      catchError((error) => {
        return this.formatErrors(error, url);
      }),
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          return event.body;
        }
        return null;
      })
    );
  }

  getExternalService(path: string, headers: any): Observable<any> {
    const request = new HttpRequest('GET', path, { headers: new HttpHeaders(headers) });
    const httpWithoutInterceptors = new HttpClient(this.httpBackend);
    return httpWithoutInterceptors.request(request).pipe(
      catchError((error) => {
        console.error('Error occurred in getExternalService:', error);
        return this.formatErrors(error, path);
      }),
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          return event.body;
        }
        return null;
      })
    );
  }

  postExternalService(path: string, body: Object = {}, headers: any): Observable<any> {
    const request = new HttpRequest('POST', path, body, { headers: new HttpHeaders(headers) });
    const httpWithoutInterceptors = new HttpClient(this.httpBackend);
    return httpWithoutInterceptors.request(request).pipe(
      catchError((error) => {
        console.error('Error occurred in postExternalService:', error);
        return this.formatErrors(error, path);
      }),
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          return event.body;
        }
        return null;
      })
    );
  }

  put(path: string, body: Object = {}): Observable<any> {
    return this.http.put(path, JSON.stringify(body)).pipe(
      catchError((error) => {
        return this.formatErrors(error);
      })
    );
  }

  patch(path: string, body: Object = {}): Observable<any> {
    return this.http.patch(path, JSON.stringify(body)).pipe(
      catchError((error) => {
        return this.formatErrors(error);
      })
    );
  }

  post(path: string, body: Object = {}, header?: any): Observable<any> {
    return this.http.post(path, JSON.stringify(body), header).pipe(
      tap(),
      catchError((error) => {
        return this.formatErrors(error);
      })
    );
  }

  putHTML(path: string, body: Object = {}): Observable<any> {
    return this.http
      .put(path, JSON.stringify(body), {
        responseType: "text",
      })
      .pipe(
        catchError((error) => {
          return this.formatErrors(error);
        })
      );
  }

  postHTML(path: string, body: Object = {}): Observable<any> {
    return this.http
      .post(path, JSON.stringify(body), {
        responseType: "text",
      })
      .pipe(
        catchError((error) => {
          return this.formatErrors(error);
        })
      );
  }

  getHTML(path: string): Observable<any> {
    return this.http
      .get(path, {
        responseType: "text",
      })
      .pipe(
        catchError((error) => {
          return this.formatErrors(error);
        })
      );
  }

  delete(path: string): Observable<any> {
    return this.http.delete(path).pipe(
      catchError((error) => {
        return this.formatErrors(error);
      })
    );
  }
}
